import React from 'react';
import Head from 'next/head';
import Contact from 'components/contact/index';
import Layout from 'components/layout';
import style from 'styles/double/classroom.module.scss';
import PlayerMobile from 'components/classroom/playerMobile';
import Introduce, { Landing, IntroduceMobile } from 'components/classroom/introduce';
import { IMG_PATH_NEW, scheme, classroom1, classroom2, classroom3, introduce1, introduce2, mobileVideo } from 'constants/classroom';

const Index = () => {
  return (
    <Layout>
      <Head>
        <title>小鱼易连-双师课堂</title>
      </Head>
      <section className={style.banner1}>
        <p>云端双师，一课又一课</p>
        <p>Hello，新教室</p>
        <Contact className={style.contact} />
      </section>
      <section className={style.banner2}>
        <div className={style.content}>
          <p className={style.quot}>互联网技术的发展推进教育信息化变革，亿万孩子同在蓝天下，共享优质教育。</p>
          <p className={style.from}>——习近平</p>
        </div>
      </section>
      <RenderPC />
      <RenderMobile />
      <Landing
        bg={`${IMG_PATH_NEW}mobile/42bdec7c02595f25f3d289e30463e3f7d657d5b34fd5d10c30b80876b0b6b078.jpg`}
        title="云端服务"
        desc={'云端统一维护、监管、升级，保障教学效果\n本地化服务，全球化业务支持，高效保障\n金融级安全保障，云服务稳定运营超过30个月'}
        descColor={'#c9d2de'}
      />
      <Contact className={style['footer-contact']} />
    </Layout>
  );
};

const RenderPC = () => {
  return (
    <div className={'for-pc'}>
      <Introduce {...classroom1} />
      <Landing
        bg={`${IMG_PATH_NEW}pc/02077b889957f17aba0d14e6c3ba4633a4e2b59e05c926654cb12cdb9712804c.jpg`}
        title="这是一间栩栩如生的双师课堂"
        desc={'核心音视频算法，保障授／听课双端互联网丢包环境下顺利上课\n自动负载均衡，异地多活，互为备份，保证云端双师课堂不中断\n延时低至40ms，1080P处理能力，保证实时高清流畅课堂效果'}
      />
      <Introduce {...Object.assign({ ...classroom2, className: style.banner5 })} />
      <section className={style.banner6}>
        <p>小鱼易连双师课堂解决方案</p>
        <div className={style.content}>
          {scheme.map((item: any) => {
            return (
              <div key={item.title} className={style.item}>
                <img className={style.icon} src={item.icon} alt="" />
                <p className={style.title}>{item.title}</p>
                <p
                  className={style.desc}
                  dangerouslySetInnerHTML={{
                    __html: item.desc.replace(/\n/, '<br/>'),
                  }}
                ></p>
              </div>
            );
          })}
        </div>
        <div className={style.terminal}>
          <div className={style.me92}>
            <div>
              <img src={`${IMG_PATH_NEW}pc/0398067d9f97972fbe47f9ff383750b7c768fa051fc7d8019a8c6be579b64e86.jpg`} alt="" />
              <div className={style.title}>大型教室授课终端ME92</div>
            </div>
          </div>
          <div className={style.cloud}>
            <img src={`${IMG_PATH_NEW}pc/42ccdb772ceec7cbc567a7059b9d7ce80830757d0f5f73f335a1d761e6e6c707.png`} alt="" />
          </div>
          <div className={style.me42}>
            <div>
              <img src={`${IMG_PATH_NEW}pc/7c23a20a32bceea953262df512cb670c6994df4da78693a8833b774c659dc755.jpg`} alt="" />
              <div className={style.title}>高性能中型教室授课终端ME42</div>
            </div>
          </div>
        </div>
      </section>
      <Landing
        bg={`${IMG_PATH_NEW}pc/f9c5d010e4d513156de2309bccdfb98627c3d1092c2d8966705c26979d906a85.jpg`}
        title="双师课堂授课端"
        desc={'20倍光学变焦摄像机，十六分屏显示听课教室，完美呈现教学细节\n专业云视频硬件终端，部署简单，高度集成，还原真实课堂互动效果\n专业的音视频终端方案，搭配双师课堂专业设备，逼真立现'}
      />
      <Introduce {...Object.assign({ ...classroom3, className: style.banner8 })} />
    </div>
  );
};

const RenderMobile = () => {
  return (
    <div className={'for-mobile'}>
      <div className={style.video}>
        {mobileVideo.map(item => {
          return <PlayerMobile key={item.title} {...item} />;
        })}
      </div>
      <IntroduceMobile list={introduce1} />
      <div className={style['scheme-m']}>
        <p className={style.title}>小鱼易连双师课堂解决方案</p>
        <div className={style.content}>
          {scheme.map(item => {
            return (
              <div key={item.title} className={style.item}>
                <img src={item.icon} className={style['item-icon']} alt="" />
                <p className={style['item-title']}>{item.title}</p>
                <p className={style['item-desc']} dangerouslySetInnerHTML={{ __html: item.descM.replace(/\n/g, '<br/>') }}></p>
              </div>
            );
          })}
        </div>
        <div className={style.terminal}>
          <div>
            <img src={`${IMG_PATH_NEW}mobile/4f2c8619a871aa43ea7702f8139675fefaf07e7708cbd6ad5e8e6c10c85f149c.jpg`} alt="" />
            <div className={style.title}>大型教室授课终端ME92</div>
          </div>
          <img src={`${IMG_PATH_NEW}mobile/2ef6b0a3a16655a0ad3c01007ab8be1b63dcef61ae8fa9c9e32d44d77d2d3ee4.png`} alt="" />
          <div>
            <img src={`${IMG_PATH_NEW}mobile/ff09ee2f30148597cd559a04a02ce9ed9971a9ffb7cf0aaf32f06fdf9452633f.jpg`} alt="" />
            <div className={style.title}>听课教室全能终端ME42</div>
          </div>
        </div>
      </div>
      <IntroduceMobile list={introduce2} />
    </div>
  );
};
export default Index;
